import { useUser } from "@clerk/react";
import { useEffect } from "react";
import { apiService } from "@/services/api";
import { upsertClientGates } from "@/lib/clientGatesStore";
import { clerkUserEmail } from "@/lib/regionAccess";

/**
 * Starts the client-ops record fetch the moment Clerk reports a signed-in user, instead of
 * waiting for the dashboard to mount and resolve the session email. The request is shared
 * (apiService dedupes record/me), so the sidebar, home view and route gates read the same
 * in-flight answer, and the gates store is filled before they first render where possible.
 */
export default function ClientGatesPrefetch() {
  const { isLoaded, isSignedIn, user } = useUser();
  const userId = user?.id || "";
  const email = clerkUserEmail(user);

  useEffect(() => {
    if (!isLoaded || !isSignedIn || (!userId && !email)) return undefined;
    let cancelled = false;
    apiService
      .getMyClientOpsRecord()
      .then((payload) => {
        const record = payload?.record || null;
        const gatesEmail = record?.client_email || email;
        if (!cancelled && record && gatesEmail) upsertClientGates(gatesEmail, record);
      })
      .catch(() => {
        // The dashboard surfaces retry on their own.
      });
    return () => {
      cancelled = true;
    };
  }, [isLoaded, isSignedIn, userId, email]);

  return null;
}
